# Winota, Joiner of Forces — Boros human / non-human aggro showcase.
#
# Load with:  just sandbox scenarios/winota.scenario
#
# Signature play — attack with a NON-Human and Winota flips a Human off the
# top of your library onto the battlefield tapped and attacking:
#     seat p1
#     goto declareattackers
#     attack <ragavan-or-gingerbrute-oid> p2
#   Winota's trigger looks at the top six and (you may) drops a Human in
#   tapped + attacking. The board print / `dump` show the new attacker.
#
# Doubles as a feature demo for engine slices added for this deck:
#   - Winota's CreatureAttacks trigger + put-onto-battlefield-tapped-attacking
#   - Ragavan's "deals combat damage to a player" trigger
#   - Esper Sentinel's first-noncreature-spell tax (SpellCast trigger)
#   - Thalia: first strike + "noncreature spells cost {1} more" (static cost mod)
#   - Grand Abolisher / Drannith Magistrate static "can't cast" locks (flip them in)
#   - Loyal Apprentice's beginning-of-combat Thopter token
#
# NB: comments must be on their own lines — a trailing "#" on a card line is
# parsed as a (bad) flag.

SEED 17
PLAYER p1 40 Winona
PLAYER p2 40 Rival
ACTIVE p1

# ── Winona's board: Winota + two non-Human attackers + a Human already online ──
p1 battlefield Winota, Joiner of Forces | commander
p1 battlefield Ragavan, Nimble Pilferer
p1 battlefield Gingerbrute
p1 battlefield Esper Sentinel
p1 battlefield Plateau
p1 battlefield Sacred Foundry

# Human in hand: first strike + a static "noncreature spells cost {1} more".
p1 hand Thalia, Guardian of Thraben

# Top of library — Winota looks at the top six; the Humans here are flip targets.
p1 library Grand Abolisher
p1 library Ranger-Captain of Eos
p1 library Drannith Magistrate
p1 library Loyal Apprentice
p1 library Mountain
p1 library Plains

# ── Rival's board: a blocker to swing into and a spell to be taxed/locked ──
p2 battlefield Grizzly Bears
p2 hand Lightning Bolt
p2 library Mountain
p2 library Mountain
